import styled, { css } from "styled-components";
import { withDynamicTag } from "./DynamicTitle";
import { color } from "../templates/ui";

const Title = styled.h1`
  color: ${props => {
    if (props.white) {
      return color.body.base;
    }
    return props.theme.tertiary;
  }};
  font-family: ${props =>
    props.baseFont ? props.theme.fontBase : props.theme.fontHead};
  font-weight: ${props => (props.fontWeight === "500" ? 500 : 700)};

  ${props =>
    props.border &&
    css`
      border-bottom: ${props => (props.border ? "1px solid #002856;" : "none")};
      padding-bottom: ${props => (props.border ? "15px;" : "0")};
    `};

  ${props =>
    props.isLoading &&
    css`
      border-bottom: none;
    `};
`;

export default withDynamicTag(Title);
